import React from 'react';
import SignUpForm from 'Components/home/SignUpForm';
import HeroImage from 'Components/home/widgets/HeroImage';
import * as actions from 'Actions';
import { connect } from 'react-redux';
import classNames from 'classnames';

class SignUp extends React.Component {
  render() {
    const { createUser, onSuccess, theme, storefrontHomeSetting } = this.props;
    const { homeVisible, homeCarouselItems } = storefrontHomeSetting;

    const isElaina = theme === 'elaina';
    const containsHomeImage = homeVisible && homeCarouselItems.length > 0;
    const shouldNotDisplayFigure = isElaina && !containsHomeImage;

    return (
      <section
        className={classNames({
          signUp: true,
          authenticationNoImageContainer: shouldNotDisplayFigure,
        })}
      >
        <HeroImage shouldNotDisplayFigure={shouldNotDisplayFigure} />
        <div className={'details'}>
          <h1 id='signUpTitle'>Sign Up for a New Way to Rent</h1>
          <p>Track rentals, make payments, request changes. You made it!</p>
        </div>
        <SignUpForm onSubmit={createUser} onSuccess={onSuccess} />
      </section>
    );
  }
}

const mapStateToProps = (state, _ownProps) => {
  const { parsedStorefrontSettings } = state.locations;
  const {
    mainSetting: { theme },
  } = parsedStorefrontSettings;

  return {
    theme,
    storefrontHomeSetting: parsedStorefrontSettings.storefrontHomeSetting,
  };
};

export default connect(mapStateToProps, actions)(SignUp);
